<template>
  <div class="banner grid">
    <div class="grid-center">
      <app-image-placeholder v-if="!dataInteraction.backgroundMobile && designMode"
                             :data-id="dataInteraction.id"
                             :dataInteraction="dataInteraction"
                             :data-parent-id="dataInteraction.campanhaId">
      </app-image-placeholder>

      <section class="coupon">
        <div class="coupon-code">
          <VueQrcode value="Wifeed"
                     :options="{ width: 227, margin: 5 }"></VueQrcode>

          <p class="coupon-code-text">Código</p>
        </div>
      </section>
    </div>

    <div class="text-center grid-bottom">
      <button class="clear-connections btn btn-stretch btn-extra-round text-bold"
              v-if="isShowingLinks && hasActiveLinks({ interaction })"
              @click="clearConnections($event, null, interaction)">Limpar conexões</button>
      <button class="btn btn-round"
              id="0"
              :style="buttonStyle(dataInteraction.estilo)"
              @click="(event) => showLinks({event, interaction})">
        Continuar
      </button>
    </div>
  </div>
</template>

<script>
    import VueQrcode from "@chenfengyuan/vue-qrcode";
    import AppImagePlaceholder from './ImagePlaceholder'
    import buttonStyle from '../mixins/button-style'
    import mode from '../mixins/mode'
    import linkable from '../mixins/linkable'

    export default {
        components: {
            AppImagePlaceholder,
            VueQrcode
        },

        props: {
            dataInteraction: {
                type: Object,
                required: true
            },
        },

        computed: {
            options() {
                return this.dataInteraction.opcoes
            },

            firstOption() {
                return this.options[0] || {
                    estilo: null,
                    nome: null
                }
            },

            secondOption() {
                return this.options[1] || {
                    estilo: null,
                    nome: null
                }
            },

            itemStyle() {
              return this.dataInteraction.estilo ? this.dataInteraction.estilo : null
            },

            backgroundType() {
              return this.itemStyle ? this.itemStyle.backgroundType : null
            },
        },

        mixins: [buttonStyle, mode, linkable],
    }
</script>

<style lang="scss" scoped>
.coupon {
  display: flex;
  height: 100%;
  align-items: flex-end;
  justify-content: center;

  .coupon-code {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    width: 227px;

    canvas {
      border-radius: 12px 12px 0 0;
      margin-bottom: -20px;
    }

    .coupon-code-text {
      width: 227px;
      border-radius: 0 0 12px 12px;
      text-align: center;
      background: white;
      font-weight: 600;
      font-size: 35px;
      margin: 0;

      z-index: 10;

      height: 43px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.grid {
  .btn {
    &.clear-connections {
      position: fixed;
      bottom: 15px;
      left: 40%;
      min-width: 0 !important;
      width: 20% !important;
      background-color: #2a7155;
      z-index: 10000;
      color: white;
      min-width: 0;

      &:hover {
        transform: translateY(-1px);
      }

      &:active {
        transform: translateY(1px);
      }
    }
  }
}
</style>
